import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router'
import { IconButton, layoutStore } from 'shared/ui'
import { IntegrationsRoutes, SettingsRoutes } from 'entities/ExportRouters'
import { WidgetChatRoutes } from 'pages/settings/pages/widgetChat/route/type'
import { useSettingsContext } from 'pages/settings/context/settingsContext'
import styles from './styles.module.scss'

export const SettingsMenuCollapseButton = observer(() => {
  const { isMobileViewWithoutMSize, width } = layoutStore
  const {
    pageLayoutStore: {
      titleIconProps,
      headerMenuTooltipIconProps,
      handleToggleCollapse,
      customCollapseWidth,
    },
  } = useSettingsContext()
  const { pathname } = useLocation()

  const isWebhookHistoryRoute = pathname.includes(
    `${SettingsRoutes.root}/${IntegrationsRoutes.root}/${IntegrationsRoutes.webhooks}/${IntegrationsRoutes.history}`
  )

  const isWidgetChatRoute = pathname.includes(`${SettingsRoutes.root}/${WidgetChatRoutes.root}`)

  const isMobileView =
    customCollapseWidth && width ? customCollapseWidth > width : isMobileViewWithoutMSize

  if (!isMobileView || isWebhookHistoryRoute || isWidgetChatRoute) return null

  return (
    <div className={styles.collapseButtonContainer}>
      <IconButton
        iconProps={{
          fontSize: titleIconProps.fontSize,
          icon: titleIconProps.icon,
        }}
        tooltipProps={headerMenuTooltipIconProps}
        variant={'icon'}
        size={'medium'}
        color={'secondary'}
        onClick={handleToggleCollapse}
        ariaLabel='SettingsMenuCollapseButton'
      />
    </div>
  )
})
